"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuccess = exports.isError = exports.isUnresolved = void 0;
var types_1 = require("../types");
var isUnresolved = function (wps) {
    return wps.status === types_1.promiseState.pending;
};
exports.isUnresolved = isUnresolved;
var isError = function (wps) {
    return wps.status === types_1.promiseState.error;
};
exports.isError = isError;
var isSuccess = function (wps) {
    return wps.status === types_1.promiseState.success;
};
exports.isSuccess = isSuccess;
